<template>
  <div>
    <vue-headful :title="doctitle" />
    <TopLandingSection />
    <Gallery />
    <ThemeIntroduction />
    <Mashup />
  </div>
</template>

<script>
import TopLandingSection from "@/components/LandingPage/TopLandingSection.vue";
import Gallery from "@/components/LandingPage/Gallery.vue";
import ThemeIntroduction from "@/components/LandingPage/ThemeIntroduction.vue";
import Mashup from "@/components/LandingPage/Mashup.vue";

export default {
  name: "LandingPage",
  components: {
    TopLandingSection,
    Gallery,
    ThemeIntroduction,
    Mashup,
  },
  data() {
    return {
      doctitle: this.$store.state.conferencename,
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/views/LandingPage.vue